const setupSwipeDetection = ({
  container,
  callback
}) => {
  const threshold = 20;
  const allowedTime = 100;
  const interactiveSelector = 'summary, details, button, a, input, [role="button"]';
  let startX = 0;
  let dist = 0;
  let elapsedTime = 0;
  let startTime = 0;
  let isInteractiveTarget = false;
  container.addEventListener(
    "touchstart",
    (event) => {
      const touchObject = event.changedTouches[0];
      const target = event.target;
      isInteractiveTarget = !!target?.closest?.(interactiveSelector);
      dist = 0;
      startX = touchObject.pageX;
      startTime = (/* @__PURE__ */ new Date()).getTime();
    },
    { passive: false }
  );
  container.addEventListener(
    "touchend",
    (event) => {
      if (isInteractiveTarget) return;
      const touchObject = event.changedTouches[0];
      dist = touchObject.pageX - startX;
      elapsedTime = (/* @__PURE__ */ new Date()).getTime() - startTime;
      if (elapsedTime > allowedTime && Math.abs(dist) >= threshold) {
        callback(dist > 0);
      }
    },
    { passive: false }
  );
};
export {
  setupSwipeDetection
};
//# sourceMappingURL=setupSwipeDetection.js.map
